import * as React from "react";
import type { SVGProps } from "react";
const SvgOptionalFacilities = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#optional-facilities_svg__a)">
      <path d="M13.64 22a3 3 0 0 1-2.14-.89L3.39 13a3 3 0 0 1-.89-2.14V7a4 4 0 0 1 4-4h3.86a3 3 0 0 1 2.14.88L20.61 12a3 3 0 0 1 0 4.28l-4.83 4.83a3 3 0 0 1-2.14.89M6.5 5a2 2 0 0 0-2 2v3.86a1 1 0 0 0 .3.72l8.12 8.12a1 1 0 0 0 1.45 0l4.83-4.83a1 1 0 0 0 0-1.45L11.08 5.3a1 1 0 0 0-.72-.3z" />
      <path d="M13.41 16.54h-.44a4.8 4.8 0 0 1-2.83-1.4c-1.7-1.7-1.91-4.25-.47-5.69a3.35 3.35 0 0 1 2.29-1 1 1 0 1 1 0 2 1.38 1.38 0 0 0-.94.37c-.65.65-.43 2 .48 2.86a2.83 2.83 0 0 0 1.63.84 1.55 1.55 0 0 0 1.23-.36 1.42 1.42 0 0 0 .37-.94 1 1 0 0 1 2 0 3.28 3.28 0 0 1-3.38 3.25z" />
      <path d="M9.66 15.16a1 1 0 0 1-.71-1.71l1.9-1.9A1.015 1.015 0 0 1 12.27 13l-1.9 1.9a1 1 0 0 1-.71.26" />
      <path d="M11.09 16.59a1 1 0 0 1-.71-.3 1 1 0 0 1 0-1.41l1.9-1.9a1 1 0 0 1 1.41 1.41l-1.9 1.9a1 1 0 0 1-.7.3" />
    </g>
    <defs>
      <clipPath id="optional-facilities_svg__a">
        <path fill="#fff" d="M2.5 3h19v19h-19z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOptionalFacilities;
